<template>
  <el-table-column
    prop="start_date"
    sortable="custom"
    label="Kezdés időpontja"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.start_date | dateTime }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'start_date',
  };
</script>
